import { useEffect, useState } from "react";
import { ApiResponse } from "../../../interfaces/ApiResponse";
import {
  Category,
  CategoryItem,
  Restaurant,
} from "../../../interfaces/Catalogue";
import { catalogueApi } from "../../../services/catalogueApi";
import MenuList from "../MenuList/MenuList";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/rootState";

interface MenuRenderProps {
  category: Category;
  userLoyalityPoints: number;
  restaurant: Restaurant | undefined;
}

export const MenuRender = (props: MenuRenderProps) => {
  const { category, userLoyalityPoints, restaurant } = props;
  const [categoryItems, setCategoryItems] = useState<CategoryItem[] | null>(
    null
  );
  const [loading, setLoading] = useState<boolean>(true);
  const selectedMode = useSelector(
    (state: RootState) => state.app.selectedMode
  );

  useEffect(() => {
    const fetchCategoryDetails = async () => {
      if (!category || !restaurant) {
        console.warn("Category or restaurant data is missing");
        return;
      }
      try {
        setLoading(true);
        const response: { data: ApiResponse<CategoryItem[]> } =
          await catalogueApi.getCategoryDetails(
            category?.id,
            restaurant?.id
          );
        const result = response.data.data.result;
        const sortedResult = result.sort((a, b) => a.orderIndex - b.orderIndex);
        setCategoryItems(sortedResult);
      } catch (error: any) {
        console.error("🚀 ~ fetchCategoryDetails ~ error:", error);
        // const { response } = error;
        // const errorCodeFI = response?.data?.failureResponse?.codeFI?.code;
        // const errorCodeReq = response?.status;
        // setError(errorCodeFI || errorCodeReq)
      } finally {
        setLoading(false);
      }
    };

    fetchCategoryDetails();


  }, [category?.id, restaurant?.id]);

  return (
    <MenuList
      loading={loading}
      categoryItems={categoryItems}
      categoryId={category?.id}
      restaurantLogo={restaurant?.imageUrl || ""}
      restaurantId={restaurant?.id}
      userLoyalityPoints={userLoyalityPoints}
    />
  );
};
